module.exports = __webpack_public_path__ + "img/logo.200f4372.png";